// const baseUrl = "http://localhost:8080/";
const baseUrl = "https://provider.numente.io/";

const authToken = localStorage.getItem("user_id");

const config = {
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${authToken}`,
  },
};

// Function to get config with token from Redux store
export const getConfigWithToken = (token) => ({
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  },
});

export { baseUrl, config };
